import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton/index";
import Zoom from "@material-ui/core/Zoom/index";
import Tooltip from "@material-ui/core/Tooltip/index";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {ReactLocalStorageService} from "../../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {PopupService} from "../../../../../settings/PoPup/PoPup";
import EmpresaAcrescoSucursalService from "../../../../../services/_Cat/EmpresaAcrescoSucursalService/EmpresaAcrescoSucursalService";
import {CONFIG} from "../../../../../settings/Config/Config";
import ModalSucursalesSAT from "./ModalSucursalesSAT";
import {DropboxApi} from "../../../../../settings/Dropbox/DropboxApi";
import {Description} from "@material-ui/icons";
import ModalEliminarSucursalesSAT from "./ModalEliminarSucursalesSAT";

class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar la sucursal ${item.nombre}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				EmpresaAcrescoSucursalService.Eliminar(item.id_empresa_sucursal, item.id_empresa).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	exportar = (path) => {
		//path = CONFIG.src + path;
		DropboxApi.Open(path).then(function (data) {
		}).catch(function (error) {
		});
		//window.open(path, '', 'width=900, height=600');
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper style={{overflowX: "auto"}}>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'center'} className={'w-10-px padding-20-L padding-10-R'}>
								ID
							</TableCell>
							<TableCell component="th" align={'left'}>Sucursal</TableCell>
							<TableCell component="th" align={'center'}>Fecha Emisión</TableCell>
							<TableCell component="th" align={'center'}>Fecha Apertura</TableCell>
							<TableCell component="th" align={'left'}>Dirección</TableCell>
							<TableCell component="th" align={'center'}>Comprobante</TableCell>
							<TableCell component="th" align={'center'}>Usuario Baja</TableCell>
							<TableCell component="th" align={'center'}>Fecha Baja</TableCell>
							<TableCell component="th" align={'center'}>Observaciones</TableCell>
							<TableCell component="th" align={'center'}>Acuse</TableCell>
							<TableCell component="th" align={'center'}>Activo</TableCell>
							<TableCell component="th" align={'center'} className={'w-110-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								<TableCell align={'center'} className={'padding-20-L padding-20-R'}>
									{item.id_empresa_sucursal}
								</TableCell>
								<TableCell align={'left'}>{item.nombre}</TableCell>
								<TableCell align={'center'}>{item.fecha_emision}</TableCell>
								<TableCell align={'center'}>{item.fecha_apertura}</TableCell>
								<TableCell align={'left'}>{item.direccion}</TableCell>
								<TableCell align={'center'}>{item.archivo ? (<Description className={'cursor-pointer'} style={{color: 'blue'}} onClick={() => this.exportar(item.archivo)} />) : "-"}</TableCell>
								<TableCell align={'left'}>{item.nombre_baja}</TableCell>
								<TableCell align={'left'}>{item.fecha_baja}</TableCell>
								<TableCell align={'left'}>{item.observaciones}</TableCell>
								<TableCell align={'center'}>{item.archivo_baja ? (<Description className={'cursor-pointer'} style={{color: 'red'}} onClick={() => this.exportar(item.archivo_baja)} />) : "-"}</TableCell>
								<TableCell align={'center'}>
									{item.activo === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									<div className={'w-auto vertical-inline'}>
										<div className={'v-center'}>
											<ModalEliminarSucursalesSAT
												tipo={'add'}
												componente={(
													<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
														<IconButton aria-label="Eliminar">
															<DeleteOutlined/>
														</IconButton>
													</Tooltip>
												)}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
										<div className={'v-center'}>
											<ModalSucursalesSAT
												tipo={'edit'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
										<div className={'v-center'}>
											<ModalSucursalesSAT
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ListaTabla;
